import React from 'react';
import './App.css';
import {AppContainer} from "./component/AppContainer";

function App() {
    return (
        <div>
            <h1>Weather App</h1>
            <AppContainer/>
            <div>Icons made by <a href="https://www.flaticon.com/authors/linector" title="Linector">Linector</a> from <a
                href="https://www.flaticon.com/" title="Flaticon">www.flaticon.com</a></div>
        </div>
    );
}

export default App;
